import script from "./workload-view-header-info-props.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-header-info-props.vue?vue&type=script&setup=true&lang=ts"

import "./workload-view-header-info-props.vue?vue&type=style&index=0&id=4f8cfef5&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8cfef5"]])

export default __exports__